<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="关联类型：" prop="relation_type">
                <el-select v-model="model.relation_type" placeholder="请选择" style="width: 200px">
                    <el-option v-for="item in enuObj('relation_type')" :key="'relation_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="灌浆记录仪：" prop="work_id">
                <el-select v-model="model.work_id" placeholder="请选择" clearable filterable style="width: 200px">
                    <el-option v-for="item in workList" :key="item.id"  :label="item.code" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据采集器：" prop="check_id" v-if="model.relation_type=='1'">
                <el-select v-model="model.check_id" placeholder="请选择" clearable filterable style="width: 200px">
                    <el-option v-for="item in checkList" :key="item.id"  :label="item.code" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="非接触设备：" prop="extract_id" v-if="model.relation_type=='2'">
                <el-select v-model="model.extract_id" placeholder="请选择" clearable filterable style="width: 200px">
                    <el-option v-for="item in extractList" :key="item.id"  :label="item.code" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="通道号：" prop="channel_no" v-if="model.relation_type=='2'">
                <el-select clearable v-model="model.channel_no" placeholder="请选择">
                    <el-option v-for="item in enuObj('channel_no')" :key="'channel_no'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间差(s)：" prop="time_difference">
                <el-input v-model.number="model.time_difference"></el-input>
            </el-form-item>
            <el-form-item label="开始时间：" prop="start_time">
                <el-date-picker v-model="model.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_time">
                <el-date-picker v-model="model.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getListData, saveModel } from '@/api/common'

export default {
    name: 'deviceRelationTimeLogEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                relation_type: '1',
                check_id: '',
                check_factory_code: '',
                check_code: '',
                work_id: '',
                work_code: '',
                extract_id: '',
                extract_factory_code: '',
                extarct_code: '',
                start_time: '',
                end_time: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/devicerelationtimelog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['relation_type', 'channel_no'],
            rules: {
                relation_type: [
                    {required: true, message: '关联类型不能为空', trigger: 'blur'}
                ],
                start_time: [
                    {required: true, message: '开始时间不能为空', trigger: 'blur'}
                ],
                time_difference: [
                    {required: true, message: '时间差不能为空', trigger: 'blur'},
                    {type: 'number', message: '时间差必须为数字值', trigger: 'blur'}
                ],
            },
            checkList: [],
            workList: [],
            extractList: [],
        };
    },
    methods: {
        loadOtherData() {
            let search_Obj = {
                "pageNum": 1,
            }
            getListData("/api/admin/devicecheck/list", search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.checkList = res.data.resultList;
                }
            })
            getListData("/api/admin/devicework/list", search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.workList = res.data.resultList;
                }
            })
            getListData("/api/admin/deviceextract/list", search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.extractList = res.data.resultList;
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/devicerelationtimelog/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.relation_type = this.model.relation_type+""
        },
    }
};
</script>